import React from "react";
import UserData from "../UserData";

function Provenance() {
  return (
    <>
      <section className="grid justify-items-center gap-2 my-10">
        <div className="w-10 h-10 rounded-full truncate cursor-pointer">
          <img src="assets/images/user/user.jpg" alt="User Image" />
        </div>
        <div className="inline-flex gap-2 font-semibold">
          <p>Auction won by</p>
          <a href="#" className="text-[#666666]">
            @weownthecity
          </a>
        </div>
        <h3 className="text-2xl font-semibold text-center">
          Sold for 2.00 ETH <span className="text-[#666666]">$5,588.52</span>
        </h3>
        <p>Jan 21, 2022 at 8:55am</p>
        <UserData />
        <UserData />
      </section>
    </>
  );
}

export default Provenance;
